export { default } from './CurieAICard';
